export default [16.44530775433784, 107.60248068835725];
